import { createSlice } from '@reduxjs/toolkit';

export const userInfoSlice = createSlice({
    name: 'userInfo',
    initialState: {
        userInfo: null,
    },
    reducers: {
        setUserInfo: (state, action) => {
            state.userInfo = action.payload
        }
    }
})
export const { setUserInfo } = userInfoSlice.actions;
export default userInfoSlice.reducer;
